import { render, staticRenderFns } from "./vipFullToast.vue?vue&type=template&id=1d45fd51&"
import script from "./vipFullToast.vue?vue&type=script&lang=ts&"
export * from "./vipFullToast.vue?vue&type=script&lang=ts&"
import style0 from "./vipFullToast.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports